<template>
  <div class="back-button">
    <div v-on:click="onClick">
      &#10096; Back
    </div>
  </div>
</template>

<script>
export default {
  name: "BackButton",
  methods: {
    onClick: function() {
      window.history.back();
    }
  }
}
</script>

<style lang="scss">
@import "src/assets/styles/variables";
.back-button {
  display: flex;
  color: #fff;
  cursor: pointer;
  user-select: none;
  justify-content: center;
  font-size: 2rem;
  padding: 0.3rem 1rem;
  background-color: #4898f9;
  position: fixed;
  bottom: 2rem;
  left: 2rem;

  @media screen and (max-width: $screen-md-max) {
    font-size: 1.2rem;
    width: 80px;
    bottom: 0.7rem;
    left: 0.7rem;
  }
}
</style>
